import TurnitinModal from './TurnitinModal';

export default TurnitinModal;
